<template>
  <div class="log-item" v-html="source.result"></div>
</template>

<script>
export default {
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>


<style lang="less" scoped>
.log-item {
  color: #27aa5e;
  font-size: 15px;
  line-height: 22px;
  height: 22px;
  white-space: nowrap;
  text-align: justify;
  font-family: JetBrains Mono;
}
</style>